<template>
  <button
    class="primary-button"
    :class="`primary-button--${mode} ${disabled ? 'disabled' : ''}`"
    @click="emitClick"
  >
    {{ text }}
  </button>
</template>

<script>
export default {
  name: "PrimaryButton",
  props: {
    text: String,
    mode: {
      type: String,
      default: "base",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    emitClick() {
      if (this.disabled) {
        return;
      }

      this.$emit("click");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/_variables.scss";
@import "~@/assets/scss/_mixins.scss";

.primary-button {
  padding: 17px 30px;
  background: $action;
  border-radius: 6px;
  color: #fff;
  font-size: pxToRem(16);
  line-height: pxToRem(19);
  transition: opacity 0.2s linear;
  border: none;
  cursor: pointer;

  &.disabled {
    opacity: 0.8;
  }

  &:hover {
    opacity: 0.8;
  }

  &--long {
    padding: 17px 75px;
  }
}
</style>
